import {useCallback, useEffect, useState} from "react";
import {apiGet} from "../utils";
import {buildLegacyApiContext, hasDateFilters} from "../utils/filters";
import {WaterfallTable} from "../components/WaterfallTable";

export const WaterfallTablePanel = ({filters}) => {
    const [tableData, setTableData] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchTableData = useCallback(() => {
        if (!hasDateFilters(filters)) {
            setLoading(false);
            return;
        }

        setLoading(true);
        const {period, granularity, queryParams} = buildLegacyApiContext(filters);
        apiGet(`calc/summary/waterfall/tabular/period/${period}/granularity/${granularity}${queryParams}`, (resp) => {
            setTableData(resp.data);
            setLoading(false);
        });
    }, [filters]);

    useEffect(() => {
        fetchTableData();
    }, [fetchTableData]);

    return (
        <WaterfallTable data={tableData} loading={loading}/>
    )
};
